import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {displayModeType} from 'src/app/Adv/search-results/search-results.component';
import * as moment from "moment";
import {MainService} from "../../Services/service.service";

@Component({
  selector: 'app-adv-small',
  templateUrl: './adv-small.component.html',
  styleUrls: ['./adv-small.component.css']
})
export class AdvSmallComponent implements OnInit {

  constructor(public service:MainService) { }

  @Input() Title: string = "";
  @Input() Tag: string = "";
  @Input() ImageUrl: string = "";
  @Input() Location: string = "";
  @Input() Date: moment.Moment;
  @Input() Description: string = "";
  @Input() DisplayMode: displayModeType;
  @Input() Expired:boolean=false;
  @Input() IsPremium: boolean = false;
  @Input() PremiumText: string = "";
  @Input() IsThirdParty: boolean = false;
 

  @Output() AdvShouldBeReposted = new EventEmitter();

  public displayModeType = displayModeType;
  
  get advDate(){
    return this.Date.format("MM/DD/YYYY hh:mm A");
  }

  ngOnInit() {
  }


  fireRepost(event: any) {
    event.stopPropagation();
    this.AdvShouldBeReposted.emit();
    return false;
  }
}
